<div class="playback-container  popup-container center">
  <mat-spinner *ngIf="data.spinner"></mat-spinner>
  <h4>{{data.title | async}}</h4>
  <div class="play-gif-container">
    <img alt="playing" src="assets/icons/playback.gif">
  </div>
  <div class="title-and-artist">
    <label id="title">{{ songTitleToDisplay }}</label>
    <label id="artist">{{ artistNameToDisplay }}</label>
  </div>
</div>
